export function parseGrimoireImport(text, tokenStore) {
    let data;
    try {
        data = JSON.parse(text);
    } catch {
        throw new Error("В буфере обмена должен быть JSON конфигурации игры.");
    }
    if (!data || !Array.isArray(data.players) || !data.players.length
        || data.players.length > 100 || !Array.isArray(data.roles) || !data.roles.length
        || !Array.isArray(data.bluffs) || data.bluffs.length > 3) {
        throw new Error("Ожидаются players (1–100 игроков), roles и bluffs (до трёх ролей).");
    }
    const characterId = (value) => {
        if (typeof value !== "string" || !value.trim()) {
            throw new Error("Не указан идентификатор роли.");
        }
        const character = tokenStore.getCharacter(value);
        if (!character) {
            throw new Error(`Неизвестная роль: ${value}. Импорт отменён.`);
        }
        return character.getId();
    };
    const roles = [...new Set(data.roles.map((role) => characterId(typeof role === "string" ? role : role?.id)))];
    const players = data.players.map((player, seat) => {
        if (!player || typeof player.name !== "string" || player.name.length > 200
            || !Array.isArray(player.reminders) || player.reminders.length > 100) {
            throw new Error(`Некорректные данные игрока ${seat + 1}.`);
        }
        return {
            id: characterId(player.role),
            name: "",
            isDead: player.isDead === true,
            reminders: player.reminders.map((reminder, index) => {
                if (!reminder || typeof reminder.name !== "string" || reminder.name.length > 500) {
                    throw new Error(`Некорректное напоминание игрока ${seat + 1}.`);
                }
                const role = tokenStore.getCharacter(characterId(reminder.role));
                let text = reminder.name;
                if (text === "Is The Drunk") {
                    text = role.getName();
                } else if (text.startsWith("Thinks: ")) {
                    const believed = tokenStore.getCharacter(text.slice(8).replace(/[^a-z0-9]/gi, ""));
                    text = `Думает: ${believed ? believed.getName() : text.slice(8)}`;
                }
                return {
                    id: `importedreminder${seat}x${index}:0`,
                    characterId: role.getId(),
                    characterName: role.getName(),
                    image: role.getImage(),
                    text,
                    imported: true
                };
            })
        };
    });
    return { roles, players, bluffs: data.bluffs.map(characterId) };
}

export function placeImportedGrimoire(data, pad, tokenStore, createReminder) {
    pad.updatePositioner({ container: true, tokens: true, total: data.players.length, layout: "ellipse" });
    const players = data.players.map((player) => {
        const info = pad.addNewCharacter(tokenStore.getCharacterClone(player.id));
        pad.setPlayerName(info.character, player.name);
        pad.toggleDead(info.character, player.isDead);
        pad.setGhostVote(info.character, true);
        return info;
    });
    const bounds = pad.getPadDimensions();
    players.forEach((info, seat) => {
        const box = info.token.getBoundingClientRect();
        const position = pad.getTokenPosition(info.token);
        const x = position.x + box.width / 2;
        const y = position.y + box.height / 2;
        const angle = Math.atan2(bounds.height / 2 - y, bounds.width / 2 - x);
        data.players[seat].reminders.forEach((reminder, index) => {
            const token = pad.addReminder(createReminder(reminder)).token;
            const size = token.getBoundingClientRect();
            const distance = box.width / 2 + size.width / 2 + index * size.width;
            pad.moveToken(token,
                Math.max(0, Math.min(bounds.width - size.width, x + Math.cos(angle) * distance - size.width / 2)),
                Math.max(0, Math.min(bounds.height - size.height, y + Math.sin(angle) * distance - size.height / 2)),
                pad.tokens.advanceZIndex());
        });
    });
}
